import React from "react";
import ForSaleWigsList from "./for-sale-wigs-list/for-sale-wigs-list";

const ForSaleWigsContainer = () => {
    return (
        <>
            <div style={{ padding: 20 }}>
                <ForSaleWigsList/>
            </div>
        </>
    )
};

export default ForSaleWigsContainer;